<template>
  <section style="display: inherit">
    <a @click="fnShowModal()" v-b-tooltip.hover title="Archive Lead">
      <span><i class="las la-trash-alt text-danger fs-1300"></i></span>
    </a>

    <b-modal ref="userModal" size="sm" hide-footer title="Archive Lead">
      <div class="d-block p-3">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12">
            <p class="mb-0">Lead Id: {{ quoteId }}</p>
            <p>Are you sure to Archive this Lead?</p>
          </div>

          <div class="col-12 text-right mt-3">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              No
            </button>
            <button
              type="button"
              @click="fnArchive()"
              class="btn btn-primary btn-sm"
            >
              <b-spinner small v-if="loading" class="mr-2"></b-spinner>
              Yes
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import * as messageService from '../../services/message.service'
import * as leadsService from '../../services/leads.service'
import * as authService from '../../services/auth.service'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalLeadsMsgVSA',
  props: ['quoteId'],
  data() {
    return {
      loginUser: {},
      errors: {},
      loading: false,
      userData: {}
    }
  },
  computed: {
    ...mapGetters(['getAdminLeadsPaginate', 'getLeadsPaginate'])
  },
  methods: {
    ...mapActions(['fetchAdminLeadsPaginate', 'fetchLeadsPaginate']),
    fnShowModal() {
      this.userData = authService.getUserFromToken()
      this.showModal()
    },
    hideModal() {
      this.$refs.userModal.hide()
    },
    showModal() {
      this.$refs.userModal.show()
    },

    fnArchive: async function () {
      this.errors = ''
      const obj = {
        status: 29
      }

      try {
        this.loading = true
        const res = await leadsService.updateLeadsStatus(this.quoteId, obj)

        if (res.status == 200) {
          if (this.userData.role_id == 3 || this.userData.role_id == 4) {
            this.fetchLeadsPaginate(this.getLeadsPaginate)
          }

          if (this.userData.role_id == 1 || this.userData.role_id == 2) {
            this.fetchAdminLeadsPaginate(this.getAdminLeadsPaginate)
          }

          this.hideModal()

          messageService.fnSweetAlertSuccessToast('Lead', 'Delete successfully')
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Lead',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast('Lead', 'Something wrong')
            break
        }

        console.log('fnDelete - Something wrong', error)
        this.loading = false
      }
    }
  }
}
</script>
